// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as UnauthorizedRouteImport } from './routes/_unauthorized'
import { Route as ProtectedIndexRouteImport } from './routes/_protected/index'
import { Route as ProtectedCallsRouteImport } from './routes/_protected/calls'
import { Route as ProtectedCommissionsRouteImport } from './routes/_protected/commissions'
import { Route as ProtectedFaqRouteImport } from './routes/_protected/faq'
import { Route as ProtectedPitchesRouteImport } from './routes/_protected/pitches'
import { Route as ProtectedSafetyRouteImport } from './routes/_protected/safety'
import { Route as ProtectedTermsRouteImport } from './routes/_protected/terms'
import { Route as UnauthorizedLoginRouteImport } from './routes/_unauthorized/login'
import { Route as UnauthorizedSignupRouteImport } from './routes/_unauthorized/signup'
import { Route as ProtectedAccountSettingsRouteImport } from './routes/_protected/account/settings'
import { Route as ProtectedCallPublicIdRouteImport } from './routes/_protected/call/$publicId'
import { Route as ProtectedPitchPublicIdRouteImport } from './routes/_protected/pitch/$publicId'
import { Route as ProtectedPitchCreateRouteImport } from './routes/_protected/pitch/create'
import { Route as UnauthorizedAccountConfirmEmailRouteImport } from './routes/_unauthorized/account/confirm-email'
import { Route as UnauthorizedAccountForgetPasswordRouteImport } from './routes/_unauthorized/account/forget-password'
import { Route as UnauthorizedAccountResetPasswordRouteImport } from './routes/_unauthorized/account/reset-password'
import { Route as UnauthorizedAuthJournalistRouteImport } from './routes/_unauthorized/auth/journalist'
import { Route as JournalistPitchesCreateRouteImport } from './routes/journalist/pitches/create'
import { Route as AdminPitchesPublicIdVersionsVersionRouteImport } from './routes/admin/pitches/$publicId/versions/$version'
import { Route as JournalistCallsPublicIdVersionsVersionRouteImport } from './routes/journalist/calls/$publicId/versions/$version'
import { Route as JournalistPitchesPublicIdVersionsVersionRouteImport } from './routes/journalist/pitches/$publicId/versions/$version'

const ProtectedRoute = ProtectedRouteImport.update({
            id: '/_protected',getParentRoute: () => rootRouteImport
          })
const UnauthorizedRoute = UnauthorizedRouteImport.update({
            id: '/_unauthorized',getParentRoute: () => rootRouteImport
          })
const ProtectedIndexRoute = ProtectedIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ProtectedRoute
          })
const ProtectedCallsRoute = ProtectedCallsRouteImport.update({
            id: '/calls',path: '/calls',getParentRoute: () => ProtectedRoute
          })
const ProtectedCommissionsRoute = ProtectedCommissionsRouteImport.update({
            id: '/commissions',path: '/commissions',getParentRoute: () => ProtectedRoute
          })
const ProtectedFaqRoute = ProtectedFaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => ProtectedRoute
          })
const ProtectedPitchesRoute = ProtectedPitchesRouteImport.update({
            id: '/pitches',path: '/pitches',getParentRoute: () => ProtectedRoute
          })
const ProtectedSafetyRoute = ProtectedSafetyRouteImport.update({
            id: '/safety',path: '/safety',getParentRoute: () => ProtectedRoute
          })
const ProtectedTermsRoute = ProtectedTermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => ProtectedRoute
          })
const UnauthorizedLoginRoute = UnauthorizedLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => UnauthorizedRoute
          })
const UnauthorizedSignupRoute = UnauthorizedSignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => UnauthorizedRoute
          })
const ProtectedAccountSettingsRoute = ProtectedAccountSettingsRouteImport.update({
            id: '/account/settings',path: '/account/settings',getParentRoute: () => ProtectedRoute
          })
const ProtectedCallPublicIdRoute = ProtectedCallPublicIdRouteImport.update({
            id: '/call/$publicId',path: '/call/$publicId',getParentRoute: () => ProtectedRoute
          })
const ProtectedPitchPublicIdRoute = ProtectedPitchPublicIdRouteImport.update({
            id: '/pitch/$publicId',path: '/pitch/$publicId',getParentRoute: () => ProtectedRoute
          })
const ProtectedPitchCreateRoute = ProtectedPitchCreateRouteImport.update({
            id: '/pitch/create',path: '/pitch/create',getParentRoute: () => ProtectedRoute
          })
const UnauthorizedAccountConfirmEmailRoute = UnauthorizedAccountConfirmEmailRouteImport.update({
            id: '/account/confirm-email',path: '/account/confirm-email',getParentRoute: () => UnauthorizedRoute
          })
const UnauthorizedAccountForgetPasswordRoute = UnauthorizedAccountForgetPasswordRouteImport.update({
            id: '/account/forget-password',path: '/account/forget-password',getParentRoute: () => UnauthorizedRoute
          })
const UnauthorizedAccountResetPasswordRoute = UnauthorizedAccountResetPasswordRouteImport.update({
            id: '/account/reset-password',path: '/account/reset-password',getParentRoute: () => UnauthorizedRoute
          })
const UnauthorizedAuthJournalistRoute = UnauthorizedAuthJournalistRouteImport.update({
            id: '/auth/journalist',path: '/auth/journalist',getParentRoute: () => UnauthorizedRoute
          })
const JournalistPitchesCreateRoute = JournalistPitchesCreateRouteImport.update({
            id: '/journalist/pitches/create',path: '/journalist/pitches/create',getParentRoute: () => rootRouteImport
          })
const AdminPitchesPublicIdVersionsVersionRoute = AdminPitchesPublicIdVersionsVersionRouteImport.update({
            id: '/admin/pitches/$publicId/versions/$version',path: '/admin/pitches/$publicId/versions/$version',getParentRoute: () => rootRouteImport
          })
const JournalistCallsPublicIdVersionsVersionRoute = JournalistCallsPublicIdVersionsVersionRouteImport.update({
            id: '/journalist/calls/$publicId/versions/$version',path: '/journalist/calls/$publicId/versions/$version',getParentRoute: () => rootRouteImport
          })
const JournalistPitchesPublicIdVersionsVersionRoute = JournalistPitchesPublicIdVersionsVersionRouteImport.update({
            id: '/journalist/pitches/$publicId/versions/$version',path: '/journalist/pitches/$publicId/versions/$version',getParentRoute: () => rootRouteImport
          })





const ProtectedRouteChildren = {
  ProtectedCallsRoute: ProtectedCallsRoute,ProtectedCommissionsRoute: ProtectedCommissionsRoute,ProtectedFaqRoute: ProtectedFaqRoute,ProtectedPitchesRoute: ProtectedPitchesRoute,ProtectedSafetyRoute: ProtectedSafetyRoute,ProtectedTermsRoute: ProtectedTermsRoute,ProtectedIndexRoute: ProtectedIndexRoute,ProtectedAccountSettingsRoute: ProtectedAccountSettingsRoute,ProtectedCallPublicIdRoute: ProtectedCallPublicIdRoute,ProtectedPitchPublicIdRoute: ProtectedPitchPublicIdRoute,ProtectedPitchCreateRoute: ProtectedPitchCreateRoute
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(ProtectedRouteChildren)




const UnauthorizedRouteChildren = {
  UnauthorizedLoginRoute: UnauthorizedLoginRoute,UnauthorizedSignupRoute: UnauthorizedSignupRoute,UnauthorizedAccountConfirmEmailRoute: UnauthorizedAccountConfirmEmailRoute,UnauthorizedAccountForgetPasswordRoute: UnauthorizedAccountForgetPasswordRoute,UnauthorizedAccountResetPasswordRoute: UnauthorizedAccountResetPasswordRoute,UnauthorizedAuthJournalistRoute: UnauthorizedAuthJournalistRoute
}

const UnauthorizedRouteWithChildren = UnauthorizedRoute._addFileChildren(UnauthorizedRouteChildren)

const rootRouteChildren = {
  ProtectedRoute: ProtectedRouteWithChildren,UnauthorizedRoute: UnauthorizedRouteWithChildren,JournalistPitchesCreateRoute: JournalistPitchesCreateRoute,AdminPitchesPublicIdVersionsVersionRoute: AdminPitchesPublicIdVersionsVersionRoute,JournalistCallsPublicIdVersionsVersionRoute: JournalistCallsPublicIdVersionsVersionRoute,JournalistPitchesPublicIdVersionsVersionRoute: JournalistPitchesPublicIdVersionsVersionRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)